import { createTheme } from "@mantine/core";

export const theme = createTheme({});
